import { render, staticRenderFns } from "./ObkDescriptionPartnerNoteStep.vue?vue&type=template&id=f62033fe&scoped=true"
import script from "./ObkDescriptionPartnerNoteStep.vue?vue&type=script&lang=js"
export * from "./ObkDescriptionPartnerNoteStep.vue?vue&type=script&lang=js"
import style0 from "./ObkDescriptionPartnerNoteStep.vue?vue&type=style&index=0&id=f62033fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62033fe",
  null
  
)

export default component.exports